import React, { Component } from 'react';
import { Table } from 'antd';
import "./style.less";

const columns = [{
  title: '套餐类型',
  dataIndex: 'type',
  render: (value, row, index) => {
    const obj = {
      children: value,
      props: {},
    };
    if (index%3 === 0) {
        obj.props.rowSpan = 3;
      }
      if (index%3 === 1 || index%3 === 2) {
          obj.props.rowSpan = 0;
        }
      return obj;
    },
}, {
  title: '推广人数',
  dataIndex: 'num',
}, {
  title: '使用者优惠（元）',
  dataIndex: 'user',
  render: (value, row, index) => {
    const obj = {
      children: value,
      props: {},
    };
    if (index%3 === 0) {
      obj.props.rowSpan = 3;
    }
    if (index%3 === 1 || index%3 === 2) {
        obj.props.rowSpan = 0;
      }
    return obj;
  },
}, {
  title: '推广者收益（元）',
  dataIndex: 'push',
}, {
  title: '推广5人收益（元）',
  dataIndex: 'pushfive',
  render: (value, row, index) => {
    const obj = {
      children: value,
      props: {},
    };
    if (index%3 === 0) {
        obj.props.rowSpan = 3;
      }
      if (index%3 === 1 || index%3 === 2) {
          obj.props.rowSpan = 0;
        }
      return obj;
    },
},{
  title: '推广10人收益（元）',
  dataIndex: 'pushten',
  render: (value, row, index) => {
    const obj = {
      children: value,
      props: {},
    };
    if (index%3 === 0) {
        obj.props.rowSpan = 3;
      }
      if (index%3 === 1 || index%3 === 2) {
          obj.props.rowSpan = 0;
        }
      return obj;
    },
},{
    title: '推广20人收益（元）',
    dataIndex: 'pushtwenty',
    render: (value, row, index) => {
        const obj = {
          children: value,
          props: {},
        };
        if (index%3 === 0) {
            obj.props.rowSpan = 3;
          }
          if (index%3 === 1 || index%3 === 2) {
              obj.props.rowSpan = 0;
            }
          return obj;
        },
  }];

const data = [{
  key: '1',
  type: '站点高级版包月',
  num: '1-4人',
  user: 5,
  push: 10,
  pushfive: 60,
  pushten: 170,
  pushtwenty: 470,
}, {
  key: '2',
  num: '5-9人',
  push: 20,
}, {
  key: '3',
  num: '>= 10人',
  push: 30,
},{
    key: '1',
    type: '站点高级版包年',
    num: '1-4人',
    user: 30,
    push: 50,
    pushfive: 300,
    pushten: 850,
    pushtwenty: 2350,
  }, {
    key: '2',
    num: '5-9人',
    push: 100,
  }, {
    key: '3',
    num: '>= 10人',
    push: 150,
  },{
    key: '1',
    type: '站点尊享版包月',
    num: '1-4人',
    user: 10,
    push: 15,
    pushfive: 90,
    pushten: 255,
    pushtwenty: 705,
  }, {
    key: '2',
    num: '5-9人',
    push: 30,
  }, {
    key: '3',
    num: '>= 10人',
    push: 45,
  },{
    key: '1',
    type: '站点尊享版包年',
    num: '1-4人',
    user: 50,
    push: 100,
    pushfive: 600,
    pushten: 1700,
    pushtwenty: 4700,
  }, {
    key: '2',
    num: '5-9人',
    push: 200,
  }, {
    key: '3',
    num: '>= 10人',
    push: 300,
  },{
    key: '1',
    type: '投票包月',
    num: '1-4人',
    user: 15,
    push: 20,
    pushfive: 120,
    pushten: 340,
    pushtwenty: 940,
  }, {
    key: '2',
    num: '5-9人',
    push: 40,
  }, {
    key: '3',
    num: '>= 10人',
    push: 60,
  },{
    key: '1',
    type: '投票包年',
    num: '1-4人',
    user: 100,
    push: 150,
    pushfive: 900,
    pushten: 2550,
    pushtwenty: 7050,
  }, {
    key: '2',
    num: '5-9人',
    push: 300,
  }, {
    key: '3',
    num: '>= 10人',
    push: 450,
  },{
    key: '1',
    type: '小程序企业展示版包年',
    num: '1-4人',
    user: 20,
    push: 50,
    pushfive: 300,
    pushten: 850,
    pushtwenty: 2350,
  }, {
    key: '2',
    num: '5-9人',
    push: 100,
  }, {
    key: '3',
    num: '>= 10人',
    push: 150,
  },
];

class RewardRule extends Component{
    render() {
        return(
            <Table size='small' pagination={false} columns={columns} dataSource={data} bordered />
        );
    }
}

export default RewardRule;